export default __webpack_public_path__ + "static/media/info-icon-purple.7d4e692a.svg";